import React from 'react'

import NoAccess from '@components/NoAccess'


/**
 * What a retired screen's old address shows to a user who cannot open its replacement: "<name> has moved", where it
 * is now, and who to ask. Never a 404 (CU-869fmjzrh P4; CU-869fmjzrg CA 22c, Curro 2026-10-27). `replacement` is a node.
 * A thin wrapper over the generic `NoAccess` (CU-869fcezdm): the two retired screens live in Business Intelligence.
 */
export default function MovedNote({ name, replacement }) {
	return <NoAccess name={name} replacement={<>{replacement}, in Business Intelligence</>}/>
}
